export default __webpack_public_path__ + "static/media/3.3da4ba33.png";